import { render, staticRenderFns } from "./DefaultLayoutV2.vue?vue&type=template&id=74a3873d&scoped=true"
import script from "./DefaultLayoutV2.vue?vue&type=script&lang=js"
export * from "./DefaultLayoutV2.vue?vue&type=script&lang=js"
import style0 from "./DefaultLayoutV2.vue?vue&type=style&index=0&id=74a3873d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a3873d",
  null
  
)

export default component.exports